/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getTankerTrucks,
    getTankerTruck,
    printTankerTruck,
    createTankerTrucks,
    updateTankerTrucks,
    deleteTankerTrucks,
} from "Modules/tanker_trucks/config/api.tanker_trucks";

const state = {
    page: {},
    form: {},
    tanker_trucks: [],
    tanker_truck_options: [],
    selectedTankerTruck: {
        truck_id: null,
        company_id: "",
        tanker_truck_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        tanker_truck_details: [],
    },
    tanker_trucks_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_tanker_trucks: {
        truck_id: {
            name: "truck_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        truck_name: {
            name: "truck_name",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        max_weight: {
            name: "max_weight",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        compartment1: {
            name: "compartment1",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "0",
        },
        compartment2: {
            name: "compartment2",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "0",
        },
        compartment3: {
            name: "compartment3",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "0",
        },
        compartment4: {
            name: "compartment4",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "0",
        },
        compartment5: {
            name: "compartment5",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "0",
        },
        num_of_compartments: {
            name: "num_of_compartments",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "5",
        },
        driver_id: {
            name: "driver_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: null,
        },
        serial: {
            name: "serial",
            rules: "trim|max_length[16]",
            max_len: "16",
            min_len: "",
            default_value: "",
        },
        meter_style: {
            name: "meter_style",
            rules: "trim|max_length[10]|required",
            max_len: "10",
            min_len: "",
            default_value: "old",
        },
        vehicle_type: {
            name: "vehicle_type",
            rules: "trim|max_length[7]",
            max_len: "7",
            min_len: "",
            default_value: "trailer",
        },
        gvwr: {
            name: "gvwr",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payload: {
            name: "payload",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    tanker_trucks: (state) => {
        return state.tanker_trucks;
    },
};

// actions
const actions = {
    async fetchTankerTrucks({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getTankerTrucks({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "tanker_truck_options",
                        with: response.data.tanker_trucks,
                    });
                } else {
                    commit("mutate", {
                        property: "tanker_trucks",
                        with: response.data.tanker_trucks,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchTankerTruck({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getTankerTruck(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedTankerTruck",
                    with: response.data.tanker_truck,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printTankerTruck({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printTankerTruck(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveTankerTruck({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["truck_id"] === "undefined" || body["truck_id"] == null || body["truck_id"] == "") {
                delete body["truck_id"];
                response = await createTankerTrucks({ body: body, headers: config.headers });
            } else {
                let truck_id = body["truck_id"];
                delete body["truck_id"];
                response = await updateTankerTrucks({ body: body, headers: config.headers }, truck_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteTankerTruck({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteTankerTrucks(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
